import styles from './TreatmentsGraph.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { ResponsiveLine } from "@nivo/line";
import moment from 'moment';
import Loader from 'components/miscellaneous/Loader/Loader';

const TreatmentsGraph = ({ dateRange }) => {
    const { startDate, endDate } = dateRange;
    const [ tick, setTick ] = useState('day')
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            setTick(res.tick)
            const dataForChart = [
                { id: 'date', data: res.data }
            ];
            setData(dataForChart)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        if (data !== null) {
            setIsLoaded(true)
        }
    }, [ data ])


    const getData = async () => {
        const data = await api.get(`dashboard/treatments/graph?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    return (<div style={ { width: '100%', height: 300, maxHeight: 340 } } className="d-flex">
        { isLoaded ? <ResponsiveLine
            data={ data }
            tooltip={ point => {
                const date = new Date(point.point.data.x);
                const sessions = point.point.data.y;
                const formattedDate = moment(date).format(tick === 'day' ? "MMM DD" : "MMM Y");
                return <div style={ {
                    background: '#fff',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                } }>{ formattedDate } - { sessions } Treatments</div>;
            } }
            margin={ { top: 30, right: 20, bottom: 45, left: 20 } }
            indexBy="date"
            pointColor={ [
                '#5c9ceb',
            ] }
            lineWidth={ 3 }
            pointBorderColor={ { from: 'serieColor' } }
            enableGridX={ false }
            enableGridY={ false }
            colors={ [
                '#93d5ed',
            ] }
            curve="monotoneX"
            useMesh={ true }
            enablePointLabel={ true }
            xScale={ {
                type: 'time',
                format: "%Y-%m-%d",
                precision: 'day',
                useUTC: false
            } }
            axisBottom={ {
                tickValues: tick === 'day' ? 'every 3 days' : 'every 1 month',
                format: tick === 'day' ? "%b %d" : "%b %Y",
                tickRotation: -45,
                legend: '',
                legendOffset: 40,
                legendPosition: 'middle',
            } }
            axisLeft={ false }
            enableArea={ true }
        /> : <div style={ { margin: 'auto' } }><Loader color="#ddd"></Loader></div> }
    </div>)
}


export default TreatmentsGraph;